import { render, staticRenderFns } from "./AddCustomer.vue?vue&type=template&id=2cdcc2ef&scoped=true&"
import script from "./AddCustomer.vue?vue&type=script&lang=js&"
export * from "./AddCustomer.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomer.vue?vue&type=style&index=0&id=2cdcc2ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdcc2ef",
  null
  
)

export default component.exports